import {View} from 'react-native'
import {ImageBackground} from 'expo-image'
import {msg} from '@lingui/core/macro'
import {useLingui} from '@lingui/react'

import {atoms as a, platform} from '#/alf'
import {Button} from '#/components/Button'
import {PlayButtonIcon} from '#/components/video/PlayButtonIcon'

export function VideoThumbnailPlaceholder({
  thumbnail,
  onPress,
  isGif = false,
}: {
  thumbnail: string | undefined
  onPress: () => void
  isGif?: boolean
}) {
  const {_} = useLingui()

  return (
    <ImageBackground
      source={thumbnail ? {uri: thumbnail} : undefined}
      accessibilityIgnoresInvertColors
      style={[a.absolute, a.inset_0, {backgroundColor: 'black'}]}
      cachePolicy="memory-disk"
      priority="high">
      <Button
        style={[a.flex_1, a.align_center, a.justify_center]}
        onPress={onPress}
        label={isGif ? _(msg`Play GIF`) : _(msg`Play video`)}>
        <View
          style={[
            a.align_center,
            a.justify_center,
            platform({
              ios: {zIndex: 1},
              android: {display: 'flex'},
            }),
          ]}>
          <PlayButtonIcon />
        </View>
      </Button>
    </ImageBackground>
  )
}
